import { ButtonList } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import type { Conversation } from 'lib-shared-types-api';
import { MouseEventHandler, useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { ConversationsTableRowMenuItemBaseProps } from '../conversationsTableRowMenuItem.types';

type ConversationsTableRowMenuTransferToQueueProps = {
  /** The conversation to transfer. */
  conversation: Conversation;
} & ConversationsTableRowMenuItemBaseProps;

/** Represents the component for transferring the conversation to a queue. */
export const ConversationsTableRowMenuTransferToQueue = ({
  conversation,
  toggleDropdown,
}: ConversationsTableRowMenuTransferToQueueProps): JSX.Element => {
  const dispatch = useAppDispatch();

  /** Handles transferring the conversation to a queue. */
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
    toggleDropdown();

    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:conversationQueueTransfer',
          arg: {
            csid: conversation.id,
            isWarmTransferAvailable: false,
          },
        },
      }),
    );

    ampli.conversationsTransferToQueueClicked();
  }, [conversation.id, dispatch, toggleDropdown]);

  return (
    <ButtonList.Item onClick={handleClick}>Transfer to queue</ButtonList.Item>
  );
};
